import { systemApi } from '../../../redux/api/SystemApi';
import { CommonListQuery } from '../../../redux/api/apiTypes';
import { EventList, EventResponse, EventSearch } from '../types';


export const eventApi = systemApi.injectEndpoints({
    endpoints: (builder) => ({
        getEventList: builder.query<EventList, EventSearch & CommonListQuery>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `event/search?page=${page || 0}&size=${size || 10}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest,
                })
            },
            transformResponse: (response: { body: EventList }, meta, arg) => {
                return response.body;
            }
        }),
        getEventById: builder.query<EventResponse, number>({
            query: (id) => `event/${id}`,
            transformResponse: (response: { body: EventResponse }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const {
    useLazyGetEventListQuery,
    useLazyGetEventByIdQuery } = eventApi;
